/**
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { createModel, type MutationsObject } from '@kp/js-model';
import { Liegenschaft } from '../Liegenschaft';
import { BaseModel } from '../BaseModel';

export class LiegenschaftData extends BaseModel {
    liegenschaft: Liegenschaft | null = null;
    liegenschaft_zusatzdaten: { [key: string]: { value: number | string | null, display: string | null } } = {}

    public mutations(): MutationsObject {
        return {
            liegenschaft: (val: Liegenschaft) => createModel(Liegenschaft, val),
        };
    }
}
